import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import QuestionnairesService from 'shared/services/QuestionnairesService';

import {
  getQuestionnaires as getQuestionnairesAction,
  setQuestionnairesData,
  getQuestionnairesFail
} from './questionnaires.redux';
import { IQuestionnaire } from 'shared/interfaces/questionnaire.interface';

function* getQuestionnaires() {
  try {
    const result: AxiosResponse<IQuestionnaire[]> = yield call(
      QuestionnairesService.getQuestionnaires
    );

    yield put(setQuestionnairesData(result));
  } catch (error) {
    console.log('error', error);
    yield put(getQuestionnairesFail());
  }
}

function* Questionnaires() {
  yield takeLatest(getQuestionnairesAction.type, getQuestionnaires);
}

export default Questionnaires;
